import React from "react";

import { SettingsPageLayout as Layout } from "Containers/Settings/SettingsHub/SettingsPageLayout";
import { lazyLoader } from "Service/loader";
const Billing = lazyLoader(
  () => import("Containers/Settings/GeneralSettings/Billing/Billing"),
);

export const GeneralSettingBilling = () => {
  return (
    <Layout>
      <Billing />
    </Layout>
  );
};
